import React from 'react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    name: "Priya Menon",
    feedback: "Catapult Media Work truly brought our corporate vision to life. Every detail was handled with care and precision.",
    role: "HR Manager, Infosys"
  },
  {
    name: "Arun Raj",
    feedback: "Their creative execution of our product launch was beyond expectations. Highly professional team!",
    role: "Marketing Lead, TechNova"
  },
  {
    name: "Divya Sharma",
    feedback: "From start to finish, the Catapult team made sure everything went smoothly. Will definitely work with them again.",
    role: "Event Coordinator, Axis Bank"
  }
];

const Testimonials = () => {
  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-overlay">
        <motion.h2
          className="section-title"
          style={{color: 'white'}}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          What Clients Say
           <div className="section-divider"></div>
        </motion.h2>

        <div className="testimonials-container">
          {testimonials.map((t, index) => (
            <motion.div
              className="testimonial-card"
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <p className="feedback">“{t.feedback}”</p>
              <p className="name">— {t.name}</p>
              <p className="role">{t.role}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Testimonials